// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3JovA","info":"Note_info__33rTc","note":"Note_note__2d4i4","actions":"Note_actions__MUF-G"};